import { render, staticRenderFns } from "./WhatsappCallingPage.vue?vue&type=template&id=65327d37&scoped=true&"
import script from "./WhatsappCallingPage.vue?vue&type=script&lang=js&"
export * from "./WhatsappCallingPage.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappCallingPage.vue?vue&type=style&index=0&id=65327d37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65327d37",
  null
  
)

export default component.exports